import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { LoggingService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    constructor() {}

    getQueryString(stringToFind: string) {
        const stringToFindUpper = stringToFind.toLocaleUpperCase();
        const myHref = window.location.href;
        const indexOfDelim = myHref.indexOf('?');
        if (indexOfDelim < 0) {
            return '';
        }
        const urlParts = myHref.substr(indexOfDelim + 1);
        let decoded = '';
        const params = urlParts.split('&');

        for (const param of params) {
            if (param.indexOf(stringToFindUpper) > -1 || param.indexOf(stringToFind) > -1) {
                const indexOfEquals = param.indexOf('=');
                decoded = param.substr(indexOfEquals + 1);
            }
        }
        return decoded;
    }

    emptyOrNull(val: string) {
        let emptyOrNull = false;
        if (val === null || val === undefined || val.length === 0) {
            emptyOrNull = true;
        }
        return emptyOrNull;
    }

    getFormValidationErrors(form: FormGroup) {
        LoggingService.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

        let totalErrors = 0;

        Object.keys(form.controls).forEach((key) => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                totalErrors++;
                Object.keys(controlErrors).forEach((keyError) => {
                    LoggingService.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
        LoggingService.log('Number of errors: ', totalErrors);
    }
}
